/*External dependencies */
import { filter, switchMap } from 'rxjs';

/*Local dependencies */
import { setAuthenticatedClient } from '../../../../../../client/graphql';
import { ListDevices } from '../../createDevice/redux/types';
import { listDevicesQuery } from '../../listDevices/redux/queries';
import { ApproveDeviceActions, approveDeviceFailed, ApproveDeviceRequestType, approveDeviceSucceeded } from './actions';
import { approveDeviceMutation } from './queries';

export function approveDeviceEpic( action$ ) {
  return action$.pipe(
    filter( ( action: ApproveDeviceRequestType ) => action.type === ApproveDeviceActions.APPROVE_DEVICE_REQUEST ),
    switchMap( ( { input }: ApproveDeviceRequestType ) =>
      approveDevice( input ).then( approveDeviceSucceeded ).catch( approveDeviceFailed ),
    ),
  );
}

async function approveDevice( input ) {
  const graphQLClient = await setAuthenticatedClient();

  const {
    data: { approveDevice: device },
  } = await graphQLClient.mutate( {
    mutation: approveDeviceMutation,
    variables: {
      input
    },
  } );

  const existingData = await graphQLClient.cache.readQuery<{ listDevices: ListDevices }>( {
    query: listDevicesQuery,
    variables: {
      input: {}
    }
  } )

  if ( existingData?.listDevices ) {
    const { devices } = existingData?.listDevices
    const result = {
      ...existingData.listDevices,
      devices: [...devices.filter( device => device.id !== input.id ), device]
    }

    graphQLClient.cache.writeQuery( {
      query: listDevicesQuery,
      variables: { input: {} },
      data: {
        listDevices: result
      }
    } )
  }

  return device;
}
